define([
    "skylark-utils/geom"
], function(geom) {
    return geom;
});
